import { Tooltip } from "@suraasa/placebo-ui"
import { Typography } from "@suraasa/placebo-ui-legacy"
import clsx from "clsx"
import { InfoCircle } from "iconoir-react"
import { pluralize } from "utils/helpers"

import SingleAiSparkle from "../assets/SingleAiSparkle"
import { useSuraasaPlusContext } from "../context"

const GenerationsAvailable = () => {
  const {
    canGenerate,
    remainingGenerations,
    aiToolGenerationsAllowed,
    isFreeTrialAvailable,
    initiateSuraasaPlusPurchaseFlow,
  } = useSuraasaPlusContext()

  if (
    remainingGenerations !== undefined &&
    aiToolGenerationsAllowed !== undefined &&
    aiToolGenerationsAllowed !== -1
  ) {
    return (
      <div className="flex shrink-0 flex-row items-center gap-1">
        <div
          className={clsx("rounded-[9px] p-[7px]", {
            "bg-[#DAE2EB]": !canGenerate,
            "bg-[#2563EB]": canGenerate,
          })}
        >
          <SingleAiSparkle height={14} width={14} fill="#FFFF" />
        </div>
        <Typography variant="strongSmallBody">
          <span
            className={clsx({
              "text-critical-400": !canGenerate,
              "text-onSurface-900": canGenerate,
            })}
          >
            {remainingGenerations}
          </span>{" "}
          <span className="text-smallBody text-onSurface-500">
            {pluralize("generation", remainingGenerations, { skipCount: true })}{" "}
            available
          </span>
        </Typography>

        <Tooltip
          content={
            <Typography className="text-smallBody text-surface">
              {!canGenerate
                ? "Daily limit reached. Unlock unlimited access with"
                : `You can generate with Suraasa AI ${pluralize(
                    "time",
                    aiToolGenerationsAllowed
                  )} per day. Unlock unlimited access with`}{" "}
              <span className="text-strongSmallBody text-surface">
                Suraasa Plus.{" "}
              </span>
              <button
                onClick={() => {
                  initiateSuraasaPlusPurchaseFlow()
                }}
                className="text-interactive-400 underline"
              >
                {isFreeTrialAvailable ? "Try Now" : "Get Now"}
              </button>
            </Typography>
          }
        >
          <InfoCircle className="size-1.75 shrink-0 text-onSurface-400" />
        </Tooltip>
      </div>
    )
  }
  return
}

export default GenerationsAvailable
